import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

var styles = function styles(theme) {
  return {
    content: {
      display: 'block',
      padding: 0,
      paddingBottom: '14px'
    },
    accordionSummary: {
      minHeight: '33px',
      height: '33px',
      boxShadow: 'none',
      padding: 0
    },
    expanded: {
      '&$expanded': {
        display: 'flex',
        minHeight: '33px',
        height: '33px',
        margin: '0',
        alignItems: 'center'
      }
    },
    expansionPanelContainer: {
      boxShadow: 'none',
      border: 'none',
      '&::after': {
        content: '\'\'',
        position: 'absolute',
        left: 0,
        bottom: 0,
        height: '1px',
        width: '100%',
        borderBottom: '1px solid #D7DAE2'
      },
      '&::before': {
        height: '0'
      }
    },
    expansionPanelContainerExpanded: {
      margin: '0'
    }
  };
};

var Accordion =
/*#__PURE__*/
function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion() {
    _classCallCheck(this, Accordion);

    return _possibleConstructorReturn(this, _getPrototypeOf(Accordion).apply(this, arguments));
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          header = _this$props.header,
          content = _this$props.content,
          defaultExpanded = _this$props.defaultExpanded;
      return React.createElement(ExpansionPanel, {
        classes: {
          root: classes.expansionPanelContainer,
          expanded: classes.expansionPanelContainerExpanded
        },
        defaultExpanded: defaultExpanded
      }, React.createElement(ExpansionPanelSummary, {
        classes: {
          root: classes.accordionSummary,
          expanded: classes.expanded
        },
        expandIcon: React.createElement(ExpandMoreIcon, null)
      }, header), React.createElement(ExpansionPanelDetails, {
        className: classes.content
      }, content));
    }
  }]);

  return Accordion;
}(Component);

export default withStyles(styles)(Accordion);